import { isEmpty } from '@nfctron/nexus-core';
import { useFormat } from '@nfctron/nexus-react';

import { IS_DEPLOYED } from '@root/lib/constants/common';
import { type EventColorConfig } from '@root/lib/entities/event.entity';

/**
 * Custom hook to generate URLSearchParams for event OG image
 */
export const useEventOgImageParams = (event: {
	namePub: string;
	subtitle?: string;
	logoUrl?: string;
	takesPlaceFrom: Date;
	takesPlaceTo: Date;
	place: string;
	eventColors: EventColorConfig;
}) => {
	const format = useFormat();
	const params = new URLSearchParams();
	params.append('title', event.namePub);
	if (!isEmpty(event.subtitle)) params.append('subtitle', event.subtitle);
	if (!isEmpty(event.logoUrl)) params.append('logoUrl', event.logoUrl);
	params.append('date', format.eventDateRange(event.takesPlaceFrom, event.takesPlaceTo));
	params.append('place', event.place);
	params.append('bgColor', event.eventColors.background);
	params.append('textColor', event.eventColors.text);
	params.append('nameColor', event.eventColors.name);
	params.append('subtitleColor', event.eventColors.subtitle);
	params.append('debug', IS_DEPLOYED ? 'false' : 'true');
	return params;
};
